import { DEFAULT_SUITE_SETTINGS, type SuiteSettings } from "./types";

const KEY = "agentforge.suite.v1";

/** Production hosts → public suite relay; local dev → localhost forge-backend. */
export function resolveDefaultForgeApiUrl(): string {
  if (typeof window === "undefined") return DEFAULT_SUITE_SETTINGS.forgeApiUrl;
  const h = window.location.hostname.toLowerCase();
  if (
    h === "agentforge.forgesuiteui.app" ||
    (h.includes("agentforge") && h.endsWith(".pages.dev"))
  ) {
    // Same forge-backend plane as BookForge (catalog + connections)
    return "https://bookforge-relay.forgesuiteui.app";
  }
  return DEFAULT_SUITE_SETTINGS.forgeApiUrl;
}

function isLocalRelay(url: string): boolean {
  return /localhost|127\.0\.0\.1/i.test(url || "");
}

export function loadSuiteSettings(): SuiteSettings {
  const prodDefault = resolveDefaultForgeApiUrl();
  if (typeof localStorage === "undefined") {
    return { ...DEFAULT_SUITE_SETTINGS, forgeApiUrl: prodDefault };
  }
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) {
      return { ...DEFAULT_SUITE_SETTINGS, forgeApiUrl: prodDefault };
    }
    const parsed = {
      ...DEFAULT_SUITE_SETTINGS,
      ...JSON.parse(raw),
    } as SuiteSettings;
    if (!isLocalRelay(prodDefault) && isLocalRelay(parsed.forgeApiUrl)) {
      parsed.forgeApiUrl = prodDefault;
    }
    return parsed;
  } catch {
    return { ...DEFAULT_SUITE_SETTINGS, forgeApiUrl: prodDefault };
  }
}

export function saveSuiteSettings(s: SuiteSettings): void {
  if (typeof localStorage === "undefined") return;
  localStorage.setItem(KEY, JSON.stringify(s));
}
